export default {
  insurance: 'التأمين',
  insurancePolicies: 'بوليصة التأمين',
  insuranceCustomers: 'العملاء',
  insuranceCompanies: 'شركات التأمين',
  settings: 'الضبط'
}
